import "react-toastify/dist/ReactToastify.css";

import { ErrorBoundary } from "@components/shared/error-boundary/ErrorBoundary";
import { Footer } from "@components/shared/footer/Footer";
import { Hero } from "@components/shared/hero/Hero";
import { Nav } from "@components/shared/nav/Nav";
import { TrustStrip } from "@components/shared/trust-strip/TrustStrip";
import { lazy, Suspense, useEffect } from "react";
import { ToastContainer } from "react-toastify";

const Solution = lazy(() =>
  import("@components/shared/solution/Solution").then((m) => ({ default: m.Solution }))
);
const MerchantPortal = lazy(() =>
  import("@components/shared/merchant-portal/MerchantPortal").then((m) => ({
    default: m.MerchantPortal,
  }))
);
const RoutingCascading = lazy(() =>
  import("@components/shared/routing-cascading/RoutingCascading").then((m) => ({
    default: m.RoutingCascading,
  }))
);
const FintechSolutions = lazy(() =>
  import("@components/shared/fintech-solutions/FintechSolutions").then((m) => ({
    default: m.FintechSolutions,
  }))
);
const WhiteLabel = lazy(() =>
  import("@components/shared/white-label/WhiteLabel").then((m) => ({ default: m.WhiteLabel }))
);
const Dashboard = lazy(() =>
  import("@components/shared/dashboard/Dashboard").then((m) => ({ default: m.Dashboard }))
);
const FAQ = lazy(() => import("@components/shared/faq/FAQ").then((m) => ({ default: m.FAQ })));
const Contact = lazy(() =>
  import("@components/shared/contact/Contact").then((m) => ({ default: m.Contact }))
);

import { useThemeColor } from "@hooks/useThemeColor";

const tweaks = { animations: true, gradientHero: true };

export function App() {
  useEffect(() => {
    document.body.dataset.anim = tweaks.animations ? "on" : "off";
  }, []);

  useThemeColor();

  return (
    <div>
      <Nav />
      <main>
        <Hero gradientHero={tweaks.gradientHero} />
        <TrustStrip />
        <Suspense fallback={null}>
          <ErrorBoundary>
            <Solution />
          </ErrorBoundary>
          <ErrorBoundary>
            <MerchantPortal />
          </ErrorBoundary>
          <ErrorBoundary>
            <RoutingCascading />
          </ErrorBoundary>
          <ErrorBoundary>
            <FintechSolutions />
          </ErrorBoundary>
          <ErrorBoundary>
            <WhiteLabel />
          </ErrorBoundary>
          <ErrorBoundary>
            <Dashboard />
          </ErrorBoundary>
          <ErrorBoundary>
            <FAQ />
          </ErrorBoundary>
          <ErrorBoundary>
            <Contact />
          </ErrorBoundary>
        </Suspense>
      </main>
      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>
      <ToastContainer position="top-right" autoClose={5000} theme="light" />
    </div>
  );
}
